import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
    this.#lazyLoadImages();
  }

  /**
   * Adds loading="lazy" to below-fold RTE images and restores aspect-ratio
   * from CDN filenames (e.g. "photo-1024x735.jpg" → aspect-ratio:1024/735).
   *
   * Shopify's article body sanitiser strips the loading attribute and the
   * aspect-ratio CSS property from inline styles, so both must be restored at
   * runtime to avoid layout shifts (CLS) on mobile.
   *
   * The first image is intentionally left eager — it is the most likely LCP
   * candidate and should not incur an extra lazy-load delay.
   */
  #lazyLoadImages() {
    const imgs = this.querySelectorAll('img');
    imgs.forEach((img, index) => {
      if (index > 0 && !img.hasAttribute('loading')) {
        img.setAttribute('loading', 'lazy');
      }

      if (!img.style.aspectRatio) {
        const match = img.src.match(/[_-](\d+)x(\d+)\.\w+/);
        if (match) {
          img.style.aspectRatio = `${match[1]} / ${match[2]}`;
        }
      }
    });
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
